/**
 * 1. 跨浏览器的getScrollHeight、setScrollTop和getScrollTop
 * 2. 有过渡效果的scroll工具函数
 */

import {Stream} from 'xstream';

var tween = {
    quartic: {
        In: function(k) {
            return k * k * k * k;
        },
        Out: function(k) {
            return 1 - (--k * k * k * k);
        },
        InOut: function(k) {
            if ((k *= 2) < 1) {
                return 0.5 * k * k * k * k;
            }

            return -0.5 * ((k -= 2) * k * k * k - 2);
        }
    }
}

export function getScrollTop() {
    return setScrollTop()
}

export function getScrollHeight() {
    return document.documentElement.scrollHeight;
}

export function setScrollTop() {
    if (arguments.length) {
        document.body.scrollTop = document.documentElement.scrollTop = arguments[0];
    } else {
        return document.body.scrollTop || document.documentElement.scrollTop
    }
}

/**
 * 有过渡效果的滚动setScroll
 * @param  {Number} vary  相对于当前scrollTop的滚动距离
 * @param  {Number} d     动画持续时间
 * @return {Undefind} 无
 */
function scrollVariate(vary, d=500) {
    var scrollTop = getScrollTop(),
        startTime = Date.now();

    Stream.loopAnimationFrame().endWhen(Stream.timeout(d)).addListener({
            next() {
                var t = scrollTop + Math.ceil(vary * tween.quartic.Out(Math.min(Date.now() - startTime, d) / d));

                /*if (n == 0) {
                    console.log(scrollTop, t)
                }*/

                setScrollTop(t);
            },
            complete() {
                setScrollTop(scrollTop + vary);
            }
        })
}

scrollVariate.setScrollTop = setScrollTop;
scrollVariate.getScrollTop = getScrollTop;
scrollVariate.getScrollHeight = getScrollHeight;

export default scrollVariate


// WEBPACK FOOTER //
// ./src/lib/scrollVariate.js